<div [ngClass]="ConfigurationOption?.SelectorClass" class="input-main-div">
  <div class="input-select-div">
      <select class="CountryDrpDwn">
      </select>
  </div>  
  <input type="text" name="InputPhone" class="CountryNumberInput form-control">
</div>
